import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
    fill?: string;
    variant?: 'dark' | 'light';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const LogoApplePay = ({ className, fill = '#000000', variant = 'light' }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width={28}
        height={20}
        viewBox='0 0 28 20'
        fill='none'
    >
        <rect
            width='28'
            height='20'
            fill={variant === 'light' ? fill : '#ffffff'}
        />
        <path
            d='M21.045 11.5324H21.0605L22.1049 8.17195H23L21.4531 12.5178C21.0999 13.5189 20.6917 13.8408 19.836 13.8408C19.7653 13.8408 19.5532 13.8329 19.4905 13.8212V13.1343C19.5532 13.1499 19.6945 13.1498 19.7652 13.1498C20.1577 13.1498 20.3698 12.985 20.4993 12.561C20.4993 12.5532 20.5738 12.3098 20.5738 12.3059L19.0821 8.17195H20.0006L21.045 11.5324Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.0823 8.0974C18.0833 8.09742 18.7231 8.62746 18.7231 9.45578V12.302H17.9105V11.6227H17.8909C17.6515 12.082 17.1294 12.3725 16.5877 12.3725C15.779 12.3725 15.2136 11.8701 15.2136 11.1281C15.2136 10.4058 15.7671 9.96214 16.7485 9.90713L17.8792 9.84047V9.52244C17.8791 9.06318 17.569 8.78846 17.051 8.78842C16.5602 8.78842 16.2539 9.02387 16.1794 9.39294H15.3784C15.4255 8.64699 16.0616 8.0974 17.0823 8.0974ZM16.8625 10.4921C16.3561 10.5274 16.0694 10.7514 16.0694 11.1047C16.0695 11.4657 16.3678 11.7013 16.8231 11.7013C17.4158 11.7013 17.8792 11.2929 17.8792 10.7551V10.4295L16.8625 10.4921Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
        <path
            d='M8.71579 7.68956C8.9121 7.70475 9.47809 7.76517 9.84035 8.30094C9.81015 8.32389 9.16867 8.69384 9.1763 9.47156C9.1838 10.4003 9.99127 10.7102 9.99885 10.7177C9.99117 10.7409 9.8705 11.1561 9.57625 11.5861C9.31964 11.9638 9.05525 12.3339 8.63259 12.3415C8.2251 12.349 8.08913 12.0995 7.6215 12.0995C7.15348 12.0995 7.00256 12.3337 6.61754 12.3489C6.21002 12.3638 5.90073 11.9482 5.64411 11.5708C5.1157 10.808 4.71577 9.41866 5.25916 8.4821C5.52337 8.014 6.00639 7.71961 6.52696 7.71195C6.92697 7.70462 7.29691 7.97655 7.53856 7.97655C7.78008 7.97648 8.21011 7.65944 8.71579 7.68956Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M13.1191 6.637C14.2183 6.637 14.9838 7.39474 14.9838 8.49787C14.9838 9.60491 14.2026 10.3666 13.0917 10.3666H11.8747V12.302H10.9954V6.637H13.1191ZM11.8747 9.62854H12.8835C13.6491 9.62854 14.0849 9.21621 14.0849 8.50169C14.0849 7.78731 13.6491 7.37894 12.8876 7.37891H11.8747V9.62854Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
        <path
            d='M8.7196 6.20499C8.75753 6.56868 8.61375 6.9248 8.40182 7.18987C8.18226 7.44746 7.83435 7.65158 7.48615 7.62137C7.44079 7.27296 7.61504 6.90231 7.81181 6.67517C8.03097 6.40991 8.40939 6.22044 8.7196 6.20499Z'
            fill={variant === 'light' ? '#ffffff' : fill}
        />
    </SvgElement>
);
